(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-now-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(e) {
    if (e.target.matches('[name="id"]')) {
      document.querySelectorAll('.buy-now-variant-id').forEach(function(input) {
        input.value = e.target.value;
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
  var prefix = document.getElementById('ContactForm-phone-prefix');
  var phone = document.getElementById('ContactForm-phone');
  if (!prefix || !phone) return;

  var form = phone.closest('form');
  if (!form) return;

  form.addEventListener('submit', function () {
    var number = phone.value.trim();
    if (number && !number.startsWith('+')) {
      phone.value = prefix.value + number;
    }
  });
})();

(function() {
  const countries = [
    { code: '+372', iso: 'ee', name: 'Estonia' },
    { code: '+34', iso: 'es', name: 'Spain' },
    { code: '+33', iso: 'fr', name: 'France' },
    { code: '+49', iso: 'de', name: 'Germany' },
    { code: '+39', iso: 'it', name: 'Italy' },
    { code: '+351', iso: 'pt', name: 'Portugal' },
    { code: '+31', iso: 'nl', name: 'Netherlands' },
    { code: '+32', iso: 'be', name: 'Belgium' },
    { code: '+43', iso: 'at', name: 'Austria' },
    { code: '+48', iso: 'pl', name: 'Poland' },
    { code: '+46', iso: 'se', name: 'Sweden' },
    { code: '+47', iso: 'no', name: 'Norway' },
    { code: '+45', iso: 'dk', name: 'Denmark' },
    { code: '+358', iso: 'fi', name: 'Finland' },
    { code: '+353', iso: 'ie', name: 'Ireland' },
    { code: '+30', iso: 'gr', name: 'Greece' },
    { code: '+420', iso: 'cz', name: 'Czech Rep.' },
    { code: '+36', iso: 'hu', name: 'Hungary' },
    { code: '+40', iso: 'ro', name: 'Romania' },
  ];

  function flagImg(iso) {
    return `<img src="https://flagcdn.com/20x15/${iso}.png" width="20" height="15" alt="${iso}" style="width:20px;height:15px;object-fit:cover;border-radius:2px;vertical-align:middle;flex-shrink:0;">`;
  }

  function getDefaultCountry() {
    const locale = navigator.language || navigator.languages?.[0] || '';
    const regionCode = locale.split('-')[1]?.toLowerCase() || locale.toLowerCase();
    return countries.find(c => c.iso === regionCode) || countries.find(c => c.iso === 'ee');
  }

  const wrapper = document.getElementById('phone-prefix-custom');
  if (!wrapper) return;

  const defaultCountry = getDefaultCountry();
  const trigger = document.getElementById('phone-prefix-trigger');
  const list = document.getElementById('phone-prefix-list');
  const hidden = document.getElementById('phone-prefix-value');

  // Set trigger to default country
  trigger.innerHTML = `${flagImg(defaultCountry.iso)} <span class="phone-prefix-code">${defaultCountry.code}</span> <span class="phone-prefix-arrow">▾</span>`;

  // Set hidden input to default
  hidden.value = defaultCountry.code;

  // Build list
  list.innerHTML = countries.map(c => `
    <li data-value="${c.code}" data-iso="${c.iso}" class="${c.code === defaultCountry.code ? 'selected' : ''}">
      ${flagImg(c.iso)} ${c.name} ${c.code}
    </li>
  `).join('');

  // Toggle open
  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    list.classList.toggle('open');
  });

  // Select item
  list.querySelectorAll('li').forEach(function(li) {
    li.addEventListener('click', function() {
      hidden.value = li.dataset.value;
      trigger.innerHTML = `${flagImg(li.dataset.iso)} <span class="phone-prefix-code">${li.dataset.value}</span> <span class="phone-prefix-arrow">▾</span>`;
      list.querySelectorAll('li').forEach(l => l.classList.remove('selected'));
      li.classList.add('selected');
      list.classList.remove('open');
    });
  });

  // Close on outside click
  document.addEventListener('click', function(e) {
    if (!trigger.contains(e.target) && !list.contains(e.target)) {
      list.classList.remove('open');
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
